import { create } from "zustand";
import { persist } from "zustand/middleware";

export const THEME_OPTIONS = ["system", "light", "dark"];

export const getSystemTheme = () =>
  typeof window !== "undefined" &&
  window.matchMedia?.("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";

export const resolveTheme = (theme) =>
  theme === "system" ? getSystemTheme() : theme;

export const applyTheme = (theme) => {
  if (typeof document === "undefined") return;
  const resolvedTheme = resolveTheme(theme);
  document.documentElement.classList.toggle("dark", resolvedTheme === "dark");
  document.documentElement.dataset.theme = resolvedTheme;
};

export const initializeTheme = () => {
  if (typeof window === "undefined") return;

  try {
    const storedTheme = JSON.parse(
      window.localStorage.getItem("cyno-theme") || "{}"
    )?.state?.theme;
    applyTheme(THEME_OPTIONS.includes(storedTheme) ? storedTheme : "system");
  } catch {
    applyTheme("system");
  }
};

const useThemeStore = create(
  persist(
    (set) => ({
      theme: "system",
      setTheme: (theme) => {
        if (!THEME_OPTIONS.includes(theme)) return;
        applyTheme(theme);
        set({ theme });
      },
    }),
    { name: "cyno-theme" }
  )
);

export default useThemeStore;
